import { Img } from "containers/Manual/components/content/Image";
import { Paragraph } from "containers/Manual/components/content/Paragraph";
import { Li } from "containers/Manual/components/list/Li";
import { Ul } from "containers/Manual/components/list/Ul";
import { CardSection } from "containers/Manual/components/section/CardSection";
import { ListSection } from "containers/Manual/components/section/ListSection";

export const SIGN = () => {
  return (
    <CardSection id="SIGN" title="SIGN">
      <Paragraph>
        숫자의 부호를 결정합니다. 숫자가 양수이면 1을 반환하고, 숫자가 0이면 0을
        반환하고, 숫자가 음수면 -1을 반환합니다. 이는 Excel의 SIGN 함수와 동일한
        출력을 제공합니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>SIGN(NUMBER)</Paragraph>
        <Ul>
          <Li>
            <b>NUMBER</b>는 실수입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>SIGN(`Column`)</Paragraph>
        <Img src="computeSign" />
      </ListSection>
    </CardSection>
  );
};
